import hasPrinting from "@/mixins/hasPrinting";
import { escapeHtml } from "@/utils/escapeHtml";

const money = (value) => value.toLocaleString("sr-RS", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Štampa ekrana Finansija kao u izvještajima: otvara se poseban prozor samo sa tabelom (naslov, restoran, period), ne cijela
 * stranica sa menijem. Podaci su isti kao za CSV (getExportData -> { headers, rows, numeric? }); `numeric` je lista indeksa
 * kolona sa iznosima (desno poravnati, dvije decimale). Ekran daje `printTitle`, a može dodati i `getExportData(true)` za
 * štampu (npr. red "Početno stanje" koji CSV nema).
 */
export default {
  mixins: [hasPrinting],
  methods: {
    printTable() {
      const { headers, rows, numeric = [] } = this.getExportData(true);
      const cell = (value, index) => (numeric.includes(index) && typeof value === "number" ? money(value) : value === null || value === undefined ? "" : escapeHtml(value));
      const columns = headers.map((text, index) => ({ text: escapeHtml(text), value: `c${index}`, align: numeric.includes(index) ? "right" : "left" }));
      const items = rows.map((row) => Object.fromEntries(row.map((value, index) => [`c${index}`, cell(value, index)])));
      const shell = this.shell;
      const period = shell.showPeriod && shell.period ? `${this.localeDate(shell.period.from)} – ${this.localeDate(shell.period.to)}` : "";
      this.printDocument({
        pageTitle: `${this.$t("finance_page_title")} - ${this.printTitle}`,
        title: escapeHtml(`${this.$t("finance_page_title")}: ${this.printTitle}`),
        subtitle: escapeHtml([shell.restaurantName, period].filter(Boolean).join(" · ")),
        tables: [{ headers: columns, items }],
      });
    },
  },
};
